'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
$p = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = $p;
$p.dL = (function(element) {
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1, "com.raquo.laminar.modifiers.Modifier$$anon$1", ({
  ix: 1,
  ab: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
